import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { savedSearchSelector, setCurrentViewSavedSearch, setLoadedSavedSearch, setSavedSearches, setSavedSearchExpanded, setSelectedSavedSearch } from './reducers/SavedSearchReducer';
import SavedSearchApi, { DeleteSavedSearchParam } from './api/SavedSearchApi';
import BaseResponse from '../../app/BaseResponse';
import SavedSearchModel from './models/SavedSearchModel';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CustomAccordion from '../CustomAccordion/CustomAccordion';
import { Button, Grid } from '@mui/material';
import "./SavedSearch.scss";
import { setTonnageQuery } from '../Tonnage/reducers/TonnageSearchReducer';
import TonnageQueryModel from '../Tonnage/models/TonnageQueryModel';
import { setCargoquery } from '../Cargo/reducers/CargoSearchReducer';
import CargoQueryModel from '../Cargo/models/CargoQueryModel';
import { setContactquery } from '../Contact/reducers/ContactSearchReducer';
import ContactQueryModel from '../Contact/models/ContactQueryModel';
import { setMarketInfoquery } from '../MarketInfo/reducers/MarketInfoSearchReducer';
import MarketInfoQueryModel from '../MarketInfo/models/MarketInfoQueryModel';
import { setAgentquery } from '../Agent/reducers/AgentSearchReducer';
import AgentQueryModel from '../Agent/models/AgentQueryModel';
import { setCompanyNamePICquery } from '../CompanyNamePIC/reducers/CompanyNamePICSearchReducer';
import CompanyNamePICQueryModel from '../CompanyNamePIC/models/CompanyNamePICQueryModel';
import { setSurveyorquery } from '../Surveyor/reducers/SurveyorSearchReducer';
import SurveyorQueryModel from '../Surveyor/models/SurveyorQueryModel';
import { setFixtureQuery } from '../FixtureManagement/reducers/FixtureSearchReducer';
import FixtureQueryModel from '../FixtureManagement/models/FixtureQueryModel';
import { setMyFixtureQuery } from '../MyFixtures/reducers/MyFixtureSearchReducer';
import MyFixtureQueryModel from '../MyFixtures/models/MyFixtureQueryModel';
import { setBrokerAccountquery } from '../BrokerAccount/reducers/BrokerAccountSearchReducer';
import BrokerAccountQueryModel from '../BrokerAccount/models/BrokerAccountQueryModel';

interface SavedSearchProps {
    component: ComponentType,
    onChange?: (value: string) => void,
}

export enum ComponentType {
    Tonnage = "Tonnage",
    Cargo = "Cargo",
    Contact = "Contact",
    MarketInfo = "MarketInfo",
    AreaBookmark = "AreaBookmark",
    Fixture = "Fixture",
    Agent = "Agent",
    CompanyNamePIC = "CompanyNamePIC",
    Surveyor = "Surveyor",
    MyFixture = "MyFixture",
    BrokerAccount = "BrokerAccount",
    Cash = "Cash",
    Investment = "Investment",
    Expense = "Expense",
    Budget = "Budget",
    Care = "Care",
}

const SavedSearch: React.FunctionComponent<SavedSearchProps> = (props) => {
    const dispatch = useDispatch();
    const savedSearchData = useSelector(savedSearchSelector)

    useEffect(() => {
        if (!savedSearchData.loadedData) {
            dispatch(showLoading(true));

            SavedSearchApi.GetAll()
                .then((response: BaseResponse<SavedSearchModel[]>) => {
                    if (response.success) {
                        dispatch(setSavedSearches(response.data));
                        dispatch(setLoadedSavedSearch(true));
                        loadCurentViewData(response.data);
                    } else {
                        Utility.Alert.Error(response.message);
                    }
                })
                .catch((error) => {
                    Utility.Alert.Error(error);
                })
                .finally(() => {
                    dispatch(showLoading(false));
                });
        } else {
            loadCurentViewData(savedSearchData.savedSearches);
        }

    }, [savedSearchData.loadedData]);

    const loadCurentViewData = (savedSearches: SavedSearchModel[]) => {
        let currentViewData = _.filter(savedSearches, (item) => {
            return item.component === props.component
        })

        currentViewData = _.orderBy(currentViewData, ["id"], ["desc"]);
        console.log(currentViewData);
        dispatch(setCurrentViewSavedSearch(currentViewData));
    }

    const deleteSavedSearch = (savedSearch: SavedSearchModel) => {
        dispatch(showLoading(true));

        SavedSearchApi.Delete({
            id: savedSearch.id
        } as DeleteSavedSearchParam)
            .then((response: BaseResponse<string>) => {
                if (response.success) {
                    let deletedSavedSearchIndex = _.findIndex(savedSearchData.savedSearches, (savedSearchItem) => {
                        return savedSearchItem.id === savedSearch.id;
                    });

                    let newSavedSearchData = [...savedSearchData.savedSearches];
                    newSavedSearchData.splice(deletedSavedSearchIndex, 1);

                    dispatch(setSavedSearches(newSavedSearchData));
                    loadCurentViewData(newSavedSearchData);
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            })
            .finally(() => {
                dispatch(showLoading(false));
            });
    }

    return (
        <>
            <CustomAccordion
                title={"Saved Search (" + savedSearchData.currentViewSavedSearch.length + "/20)"}
                defaultOpen={true}
                open={savedSearchData.expanded}
                onOpenChange={(isOpen: boolean) => {
                    dispatch(setSavedSearchExpanded(isOpen));
                }}
            >
                <div className="saved-search-wrapper nice-scroll">
                    {savedSearchData.currentViewSavedSearch.map((savedSearch: SavedSearchModel) => {
                        return <Grid container className="saved-search-item"
                            onClick={(event) => {
                                var target = event.target as HTMLElement;
                                if (target.tagName !== "BUTTON") {
                                    switch (props.component) {
                                        case ComponentType.Tonnage.toString():
                                            dispatch(setTonnageQuery(JSON.parse(savedSearch.queryJson) as TonnageQueryModel));
                                            break;

                                        case ComponentType.Cargo.toString():
                                            dispatch(setCargoquery(JSON.parse(savedSearch.queryJson) as CargoQueryModel));
                                            break;

                                        case ComponentType.Contact.toString():
                                            dispatch(setContactquery(JSON.parse(savedSearch.queryJson) as ContactQueryModel));
                                            break;

                                        case ComponentType.MarketInfo.toString():
                                            dispatch(setMarketInfoquery(JSON.parse(savedSearch.queryJson) as MarketInfoQueryModel));
                                            break;

                                        case ComponentType.Agent.toString():
                                            dispatch(setAgentquery(JSON.parse(savedSearch.queryJson) as AgentQueryModel));
                                            break;

                                        case ComponentType.CompanyNamePIC.toString():
                                            dispatch(setCompanyNamePICquery(JSON.parse(savedSearch.queryJson) as CompanyNamePICQueryModel));
                                            break;

                                        case ComponentType.Surveyor.toString():
                                            dispatch(setSurveyorquery(JSON.parse(savedSearch.queryJson) as SurveyorQueryModel));
                                            break;

                                        case ComponentType.Fixture.toString():
                                            dispatch(setFixtureQuery(JSON.parse(savedSearch.queryJson) as FixtureQueryModel));
                                            break;

                                        case ComponentType.MyFixture.toString():
                                            dispatch(setMyFixtureQuery(JSON.parse(savedSearch.queryJson) as MyFixtureQueryModel));
                                            break;

                                        case ComponentType.BrokerAccount.toString():
                                            dispatch(setBrokerAccountquery(JSON.parse(savedSearch.queryJson) as BrokerAccountQueryModel));
                                            break;


                                        default:
                                            break;
                                    }

                                    if (props.component === ComponentType.Tonnage) {
                                    } else {
                                    }
                                }
                            }}
                        >
                            <Grid item xs={10}>{savedSearch.name}</Grid>
                            <Grid item xs={2}>
                                <Button
                                    className='delete-saved-search-item'
                                    onClick={() => {
                                        deleteSavedSearch(savedSearch);
                                    }}
                                >
                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                </Button>
                            </Grid>
                        </Grid>;
                    })}
                </div>
            </CustomAccordion>
        </>
    )
};

export default SavedSearch;